import { observer } from "mobx-react-lite";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";

interface IProps {
  markdownText: string;
}

export const MarkdownBox = observer(({ markdownText }: IProps) => {
  return (
    <div>
      <Markdown remarkPlugins={[remarkGfm]}>{markdownText}</Markdown>
    </div>
  );
});
